module.exports = __webpack_public_path__ + "static/media/sunsetSky.1aac5b3d.webp";